import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FieldIconFragmentGql } from './FieldIconFragmentGql';

export const FlowFieldsByIdQueryGql: DocumentNode = gql`
query FlowFieldsByIdQuery(
  $flowVizportalUrlId: String!,
  $selectedOutputStepId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: FlowOutputFieldSortOrder!,
) {
  flows(filter: { vizportalUrlId: $flowVizportalUrlId }) {
    vizportalUrlId
    outputSteps(filter: { id: $selectedOutputStepId }) {
      outputFieldsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          name
          id
          ... on FlowColumnOutputField {
            column {
              id
              name
              downstreamSheetsConnection {
                totalCount
              }
              remoteType
            }
          }
          ... on FlowFieldOutputField {
            field {
              id
              name
              downstreamSheetsConnection {
                totalCount
              }
              ...FieldIconFragment
            }
          }
        }
      }
    }
  }
}
${FieldIconFragmentGql}
`;
